const switchModalEquipServQuest = {
  label: '¿Incluir opción de comentario en la pregunta?',
  label2: '¿Las acciones generadas a partir de esta pregunta hacen que el equipo no sea apto para su uso ?',
  label3: '¿Incluir la opción de archivo en cuestión?',
  labelWeight: 'Peso de la pregunta',
  labelWeightError: 'El valor debe ser mayor que cero',
  labelDescriptiveImage: 'Imagen descriptiva de la pregunta',
};

export default switchModalEquipServQuest;
